<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  </div>
  <main>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-layout class="landing-middle__layout">
            <v-flex xs12>
              <div class="landing-middle__layout-form">
                <prb-stepper v-bind:disable="!terms"></prb-stepper>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <prb-footer></prb-footer>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbStepper from './prb-stepper/PrbStepper';
import PrbFooter from './prb-footer/PrbFooter';

export default {
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Home'
  },
  components: {
    PrbToolbar,
    PrbTerms,
    PrbStepper,
    PrbFooter
  },
  computed: mapGetters([
    'termsVerified'
  ]),
  name: 'prblanding',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    }
  }
}
</script>

<style scoped>
.landing-middle__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.landing-middle__layout-form {
  padding: 5% 30% 5% 30%;
  margin-bottom: 10px;
}

@media screen and (max-width: 2000px) {
  .landing-middle__layout-form {
    padding: 5% 27% 5% 27%;
  }
}

@media screen and (max-width: 1000px) {
  .landing-middle__layout-form {
    padding: 25% 1% 25% 1%;
  }
}
</style>



// WEBPACK FOOTER //
// PrbLanding.vue?748603f6